import styled from "styled-components";

export const Button = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1000;

  display: flex;
  align-items: center;
  gap: 0.8rem;

  padding: 1.2rem 2.4rem;
  background: ${(p) => p.theme.colors.turquoiseDark};
  color: ${(p) => p.theme.colors.white};
  border: none;
  border-radius: 2.4rem;

  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0.05rem;

  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.15);

  &:hover {
    background: ${(p) => p.theme.colors.turquoise};
    box-shadow: 0 0.6rem 1.6rem rgba(0, 0, 0, 0.2);
    transform: translateY(-0.2rem);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.15);
  }

  #fb-update-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;
